export const NAMESPACE = "CalendarSectionStore ";

export const FORM_INSTANCE_ID = "CalendarFormInstanceId";

export const FIELDS_ID = {
  TASKS: "Tasks",
  EVENTS: "events",
  EVENT_FILTER: "eventFilter"
};

export const SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION =
  "SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION";
